import { isNil } from 'lodash';
import React from 'react';
import { View } from '@shared/components/View';
import { TextInput } from '@shared/components/textInput';
import { useWorkflowDispatch } from '@shared/scenes/workflows/context/context';

interface Props {
  component: MBAPI.WorkflowTemplate_components_TextComponent;
}

export function DefaultTextRow({ component }: Props) {
  const dispatch = useWorkflowDispatch();

  const onChangeText = (value: string) => {
    dispatch({
      type: 'updateComponent',
      args: {
        ...component,
        default: isNil(value) ? null : { text: value },
      } as MBAPI.WorkflowTemplate_components_TextComponent,
    });
  };

  return (
    <View paddingHorizontal={3} paddingVertical={1}>
      <TextInput value={component.default?.text} onChangeText={onChangeText} />
    </View>
  );
}
